import { render, staticRenderFns } from "./AddHostingInstitution.vue?vue&type=template&id=4cfff8f3"
import script from "./AddHostingInstitution.vue?vue&type=script&lang=js"
export * from "./AddHostingInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports